import React from "react";
import { connect } from "react-redux";
import { IStorageNodeProviderLightFilterParams } from "api/entities/storage-node-providers";
import { IAppState } from "redux/reducers";
import { FiltersBar } from "components/shared-ui/filters-bar/filters-bar";
import { QueryPropertyType, QueryTypeMap } from "utils/query-utils";

export const defaultFilters: IStorageNodeProviderFilters = {
  searchText: null,
};

export const filterNames = {
  searchText: "",
};

export const StorageNodeProviderFilterTypeMap: QueryTypeMap<IStorageNodeProviderLightFilterParams> =
  {
    q: QueryPropertyType.String,
  };

const mapStateToProps = (state: IAppState) => ({
  searchParams: state.storageProvider.page.searchParams,
});

export interface IStorageNodeProviderFilters {
  searchText: string;
}

interface IStorageNodeProviderFiltersProps extends ReturnType<typeof mapStateToProps> {
  filters: IStorageNodeProviderFilters;
  onFiltersChange: (filters: IStorageNodeProviderFilters) => void;
}

export const StorageNodeProviderFilters = connect(mapStateToProps)(
  (props: IStorageNodeProviderFiltersProps) => {
    function handleFilterChange(newFilterValues: Partial<IStorageNodeProviderFilters>) {
      props.onFiltersChange({ ...props.filters, ...newFilterValues });
    }

    return (
      <FiltersBar
        searchValue={props.filters.searchText}
        onSearchValueChanged={(searchText) =>
          handleFilterChange({ searchText })
        }
      />
    );
  }
);
